import { takeEvery, takeLatest, put } from 'redux-saga/effects';

import {
    UPDATE_QUESTION,
    UPLOAD_QUESTION_COVER,
    CREATE_QUESTION,
    UPDATE_QUESTION_FEEDBACK,
    DELETE_QUESTION,
    DELETE_QUESTION_COVER,
    HIDE_QUESTION,
    PIN_QUESTION,
    COPY_QUESTION,
    UPDATE_QUESTION_FEEDBACK_SETTINGS,
    UPDATE_QUESTION_DRAG_DROP
} from './constants';

import {
    requestQuestionUpdate,
    requestQuestionCoverUpload,
    requestQuestionCreation,
    requestQuestionFeedbackSettingsUpdate,
    requestQuestionDeleting,
    requestQuestionHide,
    requestQuestionPin,
    requestQuestionCopy,
    requestQuestionFeedbackUpload,
    requestQuestionDrop,
    requestQuestionCoverDelete
} from './api';

import {
    updateQuestionSuccess,
    uploadQuestionCoverSuccess,
    createQuestionSuccess,
    updateQuestionFeedbackSuccess,
    deleteQuestionSuccess,
    hideQuestionSuccess,
    pinQuestionSuccess,
    copyQuestionSuccess,
    updateQuestionFeedbackSettingsSuccess,
    updateQuestionDragDropSuccess,
    deleteQuestionCoverSuccess
} from './actions';
import { putActionActionBuffer } from '../../actionBuffer/actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, newQuestion}>>}
 */
function* createQuestion( actionObj ) {
    const newQuestion = yield requestQuestionCreation( actionObj.quizID, actionObj.quizLocalizationId, actionObj.question, actionObj.questionType, actionObj.langId, actionObj.resolve );

    if ( newQuestion ) {
        yield put( createQuestionSuccess( newQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, updatedQuestionPiece, type}>>}
 */
function* updateQuestion( actionObj ) {

    const requestObj = {
        [ actionObj.keyName ]: actionObj.updatedQuestionPiece,
    };

    yield put( putActionActionBuffer(
        {
            saveAction: true,
            actionBuff: [
                {
                    'updateQuestion': {
                        id: actionObj.questionID,
                        type: actionObj.keyName,
                        content: actionObj.updatedQuestionPiece

                    }
                }
            ]
        }
    ) );
    const isSuccess = yield requestQuestionUpdate( requestObj, actionObj.questionID );
    if ( isSuccess ) {
        const { id } = isSuccess;
        yield put( updateQuestionSuccess( id, isSuccess ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* uploadCover( actionObj ) {
    const updatedQuestion = yield requestQuestionCoverUpload( actionObj.questionID, actionObj.localizationID, actionObj.image, actionObj.screenType );
    if ( updatedQuestion ) {
        yield put( uploadQuestionCoverSuccess( actionObj.questionID, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* deleteCover( actionObj ) {
    const updatedQuestion = yield requestQuestionCoverDelete( actionObj.questionID, actionObj.localizationID );
    if ( updatedQuestion ) {
        yield put( deleteQuestionCoverSuccess( actionObj.questionID, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* updateFeedback( actionObj ) {
    const updatedQuestion = yield  requestQuestionFeedbackUpload( actionObj.questionID, actionObj.feedback );
    yield put( putActionActionBuffer(
        {
            saveAction: true,
            actionBuff: [
                {
                    'updateQuestionFeedback': {
                        id: actionObj.questionID,
                        content: { ...actionObj.feedback }

                    }
                }
            ]
        }
    ) );

    if ( updatedQuestion ) {
        yield put( updateQuestionFeedbackSuccess( actionObj.questionID, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* updateFeedbackSettings( actionObj ) {
    const updatedQuestion = yield requestQuestionFeedbackSettingsUpdate( actionObj.questionID, actionObj.feedbackSettings );
    if ( updatedQuestion ) {
        yield put( updateQuestionFeedbackSettingsSuccess( actionObj.curQuestionId, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* deleteQuestion( actionObj ) {
    const updatedQuestion = yield requestQuestionDeleting( actionObj.questionID, actionObj.questionType );
    if ( updatedQuestion ) {
        yield put( deleteQuestionSuccess( actionObj.curQuestion1d, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* hideQuestion( actionObj ) {

    const updatedQuestion = yield requestQuestionHide( actionObj.questionID, actionObj.questionType );

    if ( updatedQuestion ) {
        yield put( hideQuestionSuccess( actionObj.curQuestion1d, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* pinQuestion( actionObj ) {
    const updatedQuestion = yield requestQuestionPin( actionObj.questionID, actionObj.questionType );
    if ( updatedQuestion ) {
        yield put( pinQuestionSuccess( actionObj.curQuestion1d, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, type, newQuestion}>>}
 */
function* copyQuestion( actionObj ) {

    const newQuestion = yield requestQuestionCopy( actionObj.questionID, actionObj.questionType );
    if ( newQuestion ) {
        yield put( copyQuestionSuccess( actionObj.questionID, newQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{newQuestions, type}>>}
 */
function* dragDropQuestion( actionObj ) {
    const newQuestions = yield requestQuestionDrop( actionObj.quizID, actionObj.result );
    if ( newQuestions ) {
        yield put( updateQuestionDragDropSuccess( newQuestions ) );
    }
}

function* watchQuestions() {
    yield takeLatest( UPDATE_QUESTION, updateQuestion );
    yield takeLatest( UPLOAD_QUESTION_COVER, uploadCover );
    yield takeLatest( DELETE_QUESTION_COVER, deleteCover );
    yield takeEvery( CREATE_QUESTION, createQuestion );
    yield takeEvery( UPDATE_QUESTION_FEEDBACK, updateFeedback );
    yield takeLatest( DELETE_QUESTION, deleteQuestion );
    yield takeLatest( HIDE_QUESTION, hideQuestion );
    yield takeLatest( PIN_QUESTION, pinQuestion );
    yield takeEvery( COPY_QUESTION, copyQuestion );
    yield takeEvery( UPDATE_QUESTION_DRAG_DROP, dragDropQuestion );
    yield takeEvery( UPDATE_QUESTION_FEEDBACK_SETTINGS, updateFeedbackSettings );
}

export default watchQuestions;
